import { StatusBadge, EmptyState } from "@/components/common";
import { fmtDate, todayISO, PRIORITY_CLS } from "@/lib/api";

const isOverdue = (t) => t.due_date < todayISO() && ["not_started", "in_progress", "awaiting_client", "returned"].includes(t.status);
const Handling = ({ t }) => t.handling === "va_assist" ? <span className="ml-2 rounded bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">V.A</span> : null;

export default function TaskTable({ tasks, onOpen, showCompany = true }) {
  if (!tasks.length) return <EmptyState title="No tasks" hint="No tasks match these filters, or none have been created yet." testId="tasks-empty" />;
  return (
    <>
      <div className="hidden overflow-hidden rounded-lg border bg-card md:block">
        <table className="w-full text-sm" data-testid="tasks-table">
          <thead className="bg-muted/60 text-left text-xs uppercase tracking-wider text-muted-foreground">
            <tr><th className="px-4 py-3">Obligation</th>{showCompany && <th className="px-4 py-3">Company</th>}<th className="px-4 py-3">Period</th><th className="px-4 py-3">Assignee</th><th className="px-4 py-3">Due</th><th className="px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {tasks.map((t) => (
              <tr key={t.id} onClick={() => onOpen(t.id)} data-testid={`task-row-${t.id}`} className="cursor-pointer border-t transition-colors hover:bg-muted/40">
                <td className="px-4 py-3 font-medium">{t.title}<Handling t={t} />{t.needs_approval && <span className="ml-2 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800">Needs approval</span>}</td>
                {showCompany && <td className="px-4 py-3 text-muted-foreground">{t.company_name}</td>}
                <td className="px-4 py-3 font-mono text-xs">{t.period_key}</td>
                <td className="px-4 py-3 text-xs">{t.assignee_name || <span className="text-muted-foreground">Unassigned</span>}{t.priority && t.priority !== "normal" && <div className={`capitalize ${PRIORITY_CLS[t.priority]}`}>{t.priority}</div>}</td>
                <td className={`px-4 py-3 ${isOverdue(t) ? "font-semibold text-red-600" : ""}`}>{fmtDate(t.due_date)}{isOverdue(t) && " · overdue"}</td>
                <td className="px-4 py-3"><StatusBadge status={t.status} testId={`task-status-badge-${t.id}`} />{t.stage && t.status !== "cancelled" && <div className="mt-1 text-[10px] text-muted-foreground" data-testid={`task-stage-${t.id}`}>Stage {t.stage.index + 1}/6 · {t.stage.label}</div>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="space-y-2 md:hidden">
        {tasks.map((t) => (
          <button key={t.id} onClick={() => onOpen(t.id)} data-testid={`task-card-${t.id}`} className={`w-full rounded-lg border bg-card p-4 text-left ${isOverdue(t) ? "border-l-4 border-l-red-500" : ""}`}>
            <div className="flex items-start justify-between gap-2"><span className="font-semibold">{t.title}<Handling t={t} /></span><StatusBadge status={t.status} /></div>
            <div className="mt-2 flex justify-between text-xs text-muted-foreground">
              <span>{showCompany ? `${t.company_name} · ` : ""}{t.period_key}{t.assignee_name ? ` · ${t.assignee_name}` : ""}</span>
              <span className={isOverdue(t) ? "font-semibold text-red-600" : ""}>Due {fmtDate(t.due_date)}</span>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
